export class PlanFeature {

  public title: string;
  public titleShort: string;
  public info: string;
  public infoShort: string;
  public hasInfoIcon: boolean;
  public link: string;
  public features: PlanFeature[];
  public available: boolean;
  public hidden: boolean;
  public allPluginsCount: number;
  public allExtensionsCount: number;
  public value: number;

}
